import React from 'react';

import { css } from '@gogame/ui/styles';

import styled from '../../styled';
import getTextColor from './getTextColor';

export const BaseText = styled(
  React.forwardRef(
    (
      {
        intensity,
        theme,
        font,
        italic,
        lineThrough,
        lineBreaks,
        ellipsis,
        fluid,
        lowercase,
        uppercase,
        userSelect,
        align,
        size,
        spacing,
        wordBreak,
        lineClamp,
        ...props
      },
      ref
    ) => {
      return <span {...props} ref={ref} />;
    }
  )
)`
  margin: 0;
  line-height: 1.4;
  user-select: text;

  /* word-break: break-word; */

  -webkit-font-smoothing: antialiased;
  font-family: ${(props) => props.theme.typography.fontFamily};

  color: ${(props) => getTextColor(props.intensity, props.theme)};

  font-weight: ${(props) => {
    switch (props.font) {
      case 'light':
        return '500';

      case 'medium':
        return '600';

      case 'regular':
      default:
        return 'normal';
    }
  }};

  ${(props) =>
    props.italic &&
    css`
      font-style: italic;
    `};

  ${(props) =>
    props.lineThrough &&
    css`
      text-decoration: line-through;
    `};

  ${(props) =>
    props.lineBreaks &&
    css`
      white-space: pre-wrap;
    `};

  ${(props) =>
    props.ellipsis &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `};

  ${(props) =>
    props.fluid &&
    css`
      display: inline-block;
      width: 100%;
    `};

  ${(props) =>
    props.lowercase &&
    css`
      text-transform: lowercase;
    `};

  ${(props) =>
    props.uppercase &&
    css`
      text-transform: uppercase;
    `};

  ${(props) =>
    props.userSelect &&
    props.userSelect === 'none' &&
    css`
      user-select: none;
    `};

  ${(props) =>
    props.align &&
    css`
      text-align: ${props.align};
    `};

  ${(props) =>
    props.size &&
    css`
      font-size: ${props.size};
    `};

  ${(props) =>
    props.spacing &&
    css`
      letter-spacing: ${props.spacing}px;
    `};

  ${(props) =>
    props.wordBreak &&
    css`
      word-break: ${props.wordBreak};
    `}

  ${(props) =>
    props.lineClamp
      ? `
    -webkit-line-clamp:  ${props.lineClamp};
    text-overflow: ellipsis;
    white-space: normal;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    `
      : ''}
`;

BaseText.displayName = 'BaseText';
BaseText.defaultProps = {
  intensity: 300,
};

export default BaseText;
